import { render, staticRenderFns } from "./MealHolidayConfig.vue?vue&type=template&id=98b9056e&scoped=true"
import script from "./MealHolidayConfig.vue?vue&type=script&lang=js"
export * from "./MealHolidayConfig.vue?vue&type=script&lang=js"
import style0 from "./MealHolidayConfig.vue?vue&type=style&index=0&id=98b9056e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b9056e",
  null
  
)

export default component.exports